export const AppConfig = {
  apiUrl:
    process.env.NODE_ENV === 'test'
      ? 'http://app.localhost:31337'
      : typeof window !== 'undefined'
      ? window.API_URL
      : (process.env.BASE_URL as string),
} as const
